export class JSONAPIDocument {
  public id: string
  public type: string
  public attributes: any
  public relationships: any
}